/**
 * MicButton — Floating mic icon that sits inside any input/textarea.
 *
 * Usage:
 *   <div className="input-with-mic">
 *     <textarea … />
 *     <MicButton onClick={openModal} disabled={isLoading} />
 *   </div>
 *
 * The parent wrapper (.input-with-mic) must be position:relative.
 * MicButton.css sets up the absolute positioning and animations.
 */

import React from 'react';
import { FaMicrophone } from 'react-icons/fa';
import './MicButton.css';

const MicButton = ({ onClick, disabled = false, title = 'Voice input' }) => (
  <div className="mic-btn-wrapper">
    <button
      type="button"
      className="mic-btn mic-btn--idle"
      onClick={onClick}
      disabled={disabled}
      title={title}
      aria-label={title}
    >
      <FaMicrophone size={14} />
    </button>
  </div>
);

export default MicButton;
